import { useEffect, useState } from 'react'

/**
 * Dezelfde grenzen als de standaard Tailwind-schermen (`md:`, `lg:`), zodat JS en CSS
 * nooit op een andere breedte omslaan. Alleen gebruiken als het *gedrag* verandert
 * (bijv. dag- of weekweergave); voor puur uiterlijk is een Tailwind-klasse genoeg.
 */
export const screens = {
  md: '(min-width: 768px)',
  lg: '(min-width: 1024px)',
} as const

/** `true` zolang de media query klopt. Zo mount je maar één variant, in plaats van twee en er één verbergen. */
export function useMediaQuery(query: string) {
  const [matches, setMatches] = useState(() => typeof window !== 'undefined' && window.matchMedia(query).matches)
  useEffect(() => {
    const list = window.matchMedia(query)
    const update = () => setMatches(list.matches)
    update()
    list.addEventListener('change', update)
    return () => list.removeEventListener('change', update)
  }, [query])
  return matches
}
